import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@6.0.11@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-caidan_zhangguiyujing",
  "use": "icon-icon-caidan_zhangguiyujing-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 32 32\" id=\"icon-icon-caidan_zhangguiyujing\">\r\n<style type=\"text/css\">\r\n\t#icon-icon-caidan_zhangguiyujing .st0{fill:#333333;}\r\n</style>\r\n<g>\r\n\t<path class=\"st0\" d=\"M30,27h-3V14c0-6.1-4.9-11-11-11S5,7.9,5,14v13H2c-0.6,0-1,0.4-1,1s0.4,1,1,1h28c0.6,0,1-0.4,1-1\r\n\t\tS30.6,27,30,27z M7,14c0-5,4-9,9-9s9,4,9,9v13H7V14z\" />\r\n\t<polygon class=\"st0\" points=\"16.6,10 12.6,17.6 15.5,17.6 15.5,23.5 19.4,16.2 16.6,16.2 \t\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-caidan_zhangguiyujing.svg
// module id = 68Sn
// module chunks = 95